import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Title from 'lib/src/components/typography/Title';
import useResetPasswordForm from './hooks/useResetPasswordForm';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

const ResetPassword: React.FC = () => {
    const { handleChange, handleSubmit, handleCancel, isPosting, success, error, password } =
        useResetPasswordForm();
    const { validatePassword } = usePasswordValidation(password);

    return (
        <>
            <div className="login-form-wrapper">
                <div className="login-form">
                    <Title>Reset Password</Title>
                    <Form
                        onSubmit={handleSubmit}
                        onCancel={handleCancel}
                        isPosting={isPosting}
                        error={error}
                        cancelText="Go back to login"
                        omitSubmitButton={success}
                    >
                        {success ? (
                            <p style={{ marginBottom: 20 }}>
                                Your password has been successfully updated.
                            </p>
                        ) : (
                            <FormRow>
                                <TextInput
                                    name="password"
                                    type="password"
                                    value={password}
                                    label="New Password"
                                    onChange={handleChange}
                                    required
                                    customValidate={validatePassword}
                                />
                            </FormRow>
                        )}
                    </Form>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
